// extracted by mini-css-extract-plugin
export default {"downloadContainer":"src-feature-config-opportunity-product-__product_downloadContainer"};